import { noop } from 'lodash';

export default noop;
